export default "__VITE_ASSET__cFkQkTm0__ 400w, __VITE_ASSET__BXRlMaic__ 800w, __VITE_ASSET__DCxozLuQ__ 1024w";